var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInventory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_185",
    "data-name": "Group 185",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.294,
    height: 19,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_346",
    "data-name": "Rectangle 346",
    className: "cls-1",
    d: "M0 0h23.294v19H0z"
  })), /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:currnetColor}"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184",
    style: {
      clipPath: "url(#clip-path3)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    className: "cls-1",
    d: "M23.294 10.5a.583.583 0 0 0-.31-.5l-5.129-2.717.4-4.422a.538.538 0 0 0 0-.069.558.558 0 0 0-.362-.5L11.878.035a.558.558 0 0 0-.382 0l-5.932 2.1a.558.558 0 0 0-.371.555l.225 4.375L.334 9.488A.559.559 0 0 0 0 9.96v4.532a.558.558 0 0 0 .241.459l5.659 3.92a.559.559 0 0 0 .577.035L6.5 18.9l5.356-3.042 5.2 3.027a.572.572 0 0 0 .072.048.565.565 0 0 0 .272.067.587.587 0 0 0 .3-.085l5.552-3.442V10.72a.579.579 0 0 0 .039-.218M6.78 14.016l4.42-2.436.045 3.334-4.465 2.538Zm-.234-6.757-.19-3.694 4.769 2.282.053 3.891Zm5.7-1.376 4.816-2.17-.322 3.544L12.294 9.7Zm.078 5.732 4.395 2.352.092 3.478-4.446-2.585Zm4.974 1.4-4.407-2.358 4.383-2.414 4.336 2.294ZM11.677 1.152l4.559 1.706-4.516 2.035-4.514-2.16ZM5.787 8.12l4.759 2.547L6.31 13l-4.6-2.931Zm-4.67 6.08v-3.183l4.547 2.9v3.434Zm16.808 3.265-.092-3.475 4.306-2.475v3.337Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.c0ac5aa8d3c83b93fde5c78c97cf5414.svg";
export { ForwardRef as ReactComponent };